<script context="module">
    /** static properties so we can have unique ids for each Button */
    export let _id = 1;
</script>

<script>
    let _class = '';
    export { _class as class };
    export let options;
    export let flexDirection = 'row';
    export let legend;
    export let userSelected = options[0].value;
    
    const uniqueID = `vv-radio-${_id++}`;

    const slugify = (str = "") =>
        str.toLowerCase().replace(/ /g, "-").replace(/\./g, "");
</script>

<div role="radiogroup"
     class="group-container {_class}"
     aria-labelledby={`label-${uniqueID}`}
     style="flex-direction:{flexDirection}"
     id={`group-${uniqueID}`}>
    {#if legend}
        <div class="font-bold"
             id={`label-${uniqueID}`}>{legend}
        </div>
    {/if}
    {#each options as { value, label }}
        <input class="accent-[var(--vv-action-center-button-color)]"
               type="radio"
               id={slugify(label)}
               bind:group={userSelected}
               value={value} />
        <label class="mr-4" for={slugify(label)}> {label}</label>
    {/each}
</div>


